module.exports = __webpack_public_path__ + "static/img/surveys.0d7c7b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/surveys.png
// module id = mPua
// module chunks = 0